import behaviourConstants from "@/constants/behaviourManagementConstants.js"

const pages = {
  settingsPage() {
    return {
      name: "Behavior Management Settings",
      path: behaviourConstants.PATHS.SETTINGS_CORE_VALUE,
      roles: behaviourConstants.BEHAVIOUR_ADMIN_ROLES,
      dependency: behaviourConstants.ROUTE_DEPENDENCY.SETTINGS
    }
  },
  managePage() {
    return {
      name: "Behaviour Management",
      path: behaviourConstants.PATHS.POINT_HISTORY,
      roles: behaviourConstants.BEHAVIOUR_MANAGE_ROLES,
      dependency: behaviourConstants.ROUTE_DEPENDENCY.MANAGE
    }
  },
  pointHistoryPage() {
    return {
      path: behaviourConstants.PATHS.POINT_HISTORY,
      roles: behaviourConstants.BEHAVIOUR_MANAGE_ROLES,
      dependency: behaviourConstants.ROUTE_DEPENDENCY.MANAGE
    }
  },
  studentListPage() {
    return {
      path: behaviourConstants.PATHS.POINT_HISTORY,
      roles: behaviourConstants.BEHAVIOUR_STAFF_MANAGE_ROLES,
      dependency: behaviourConstants.ROUTE_DEPENDENCY.MANAGE
    }
  }
}

export default {
  pages
}
